import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function Welcome({ v }) {
  if (!v.showWelcome) return null;
  return (
    <>
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeWelcome}>
        <div className="gp-venster gp-vast" style={{ "position": "relative", "overflow": "hidden", "width": "min(700px,100%)" }} onClick={v.stopProp}>
          {' '}
          <div style={{ "position": "absolute", "top": "0", "bottom": "0", "left": "20px", "width": "42px", "background": "linear-gradient(90deg,#4a494f 0% 6%,#74737c 6% 16%,#9f9ea4 16% 27%,#c7c6c9 27% 38%,#e6e6e7 38% 47%,#f5f5f5 47% 53%,#e6e6e7 53% 62%,#c7c6c9 62% 73%,#9f9ea4 73% 84%,#74737c 84% 94%,#4a494f 94% 100%)", "boxShadow": "inset 10px 0 10px -10px rgba(30,26,48,.4),inset -10px 0 10px -10px rgba(30,26,48,.4)", "display": "flex", "flexDirection": "column", "alignItems": "center", "justifyContent": "space-between", "padding": "20px 0", "boxSizing": "border-box" }}>
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(-1px) rotate(-7deg)", "background": "#FFA300" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(3px) rotate(5deg)", "background": "#29ADFF" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(-4px) rotate(-3deg)", "background": "#FF004D" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(2px) rotate(7deg)", "background": "#008751" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(-2px) rotate(-5deg)", "background": "#D3DBE6" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(4px) rotate(4deg)", "background": "#7E2553" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(-3px) rotate(-6deg)", "background": "#1D2B53" }} />
            <div style={{ "width": "22px", "height": "22px", "flex": "0 0 auto", "transform": "translateX(1px) rotate(6deg)", "background": "#FFA300" }} />
          </div>
          {' '}
          {/* Sluiten met een kruisje rechtsboven, zoals elk ander venster hier. Op
              de telefoon is het venster schermvullend en kun je er niet naast
              tikken, dus dan is dit naast "Aan de slag" de enige uitgang. */}
          <button onClick={v.closeWelcome} title="Sluiten" style={{ "position": "absolute", "top": "14px", "right": "14px", "zIndex": "2", "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--ink)", "display": "flex", "padding": "12px", "borderRadius": "12px" }}>
            <Kruis maat={20} />
          </button>
          {/* dvh en niet vh: dit vak bepaalt de hoogte van het venster eromheen, en
              op de telefoon is 100vh de hoogte zonder adresbalk. Met vh werd het
              venster tot 78 pixels hoger dan het zichtbare vlak, en omdat het venster
              zelf niet scrollt viel dat er onderaan gewoon af. */}
          <div style={{ "position": "relative", "padding": "22px 22px 20px 80px", "display": "flex", "flexDirection": "column", "gap": "16px", "maxHeight": "calc(100dvh - 70px)", "overflowY": "auto" }}>
            <div style={{ "display": "flex", "alignItems": "baseline", "gap": "8px", "flexWrap": "wrap" }}>
              <span style={{ "fontSize": "27px", "fontWeight": "700", "letterSpacing": "-.01em" }}>
                Krabbelpaal XP zegt:
              </span>
            </div>
            <div style={{ "position": "relative", "background": "var(--lila)", "border": "3px solid var(--ink)", "borderRadius": "16px", "boxShadow": "3px 3px 0 var(--ink)", "padding": "15px 16px" }}>
              {' '}
              <span style={{ "position": "absolute", "left": "-11px", "top": "18px", "width": "18px", "height": "18px", "background": "var(--lila)", "borderLeft": "3px solid var(--ink)", "borderBottom": "3px solid var(--ink)", "borderRadius": "0 0 0 3px", "transform": "rotate(45deg)" }} />
              {' '}
              <div style={{ "position": "relative", "fontSize": "15px", "fontWeight": "600", "lineHeight": "1.4", "textWrap": "pretty" }}>
                Hallo iedereen,
                <br />
                <br />
                Er is een hoop verbouwd. Acht dingen die je gaat merken:
              </div>
              {' '}
            </div>
            {/* De acht nieuwe dingen, twee naast twee. Eén wit paneel met acht regels
                erin en geen acht vakjes met randjes: dat laatste leest als acht losse
                knoppen en maakte het venster onrustig. De tekst, het raster en het
                opsommingsteken staan in welkomNieuw, welkomLijstStyle en
                welkomTekenStyle in logic/render-vals.js. */}
            <div style={css(v.welkomLijstStyle)}>
              {toList(v.welkomNieuw).map((n, $index) => (
                <React.Fragment key={$index}>
                  <div style={{ "display": "flex", "alignItems": "flex-start", "gap": "9px" }}>
                    <span style={css(v.welkomTekenStyle)}>
                      <Interp v={n?.teken} />
                    </span>
                    <span style={{ "fontSize": "14px", "fontWeight": "600", "lineHeight": "1.35", "textWrap": "pretty", "minWidth": "0" }}>
                      <Interp v={n?.tekst} />
                    </span>
                  </div>
                </React.Fragment>
              ))}
            </div>
            <div style={{ "display": "flex", "alignItems": "center" }}>
              <button onClick={v.closeWelcome} className="gp-btn pink" style={{ "flex": "1 1 auto", "justifyContent": "center", "fontSize": "15px" }}>
                Aan de slag
              </button>
            </div>
            <div style={{ "display": "flex", "justifyContent": "center" }}>
              <button onClick={v.requestFeature} className="gp-feature-btn gp-wiggle" style={{ "border": "none", "background": "transparent", "cursor": "pointer", "color": "var(--tekst-2)", "fontFamily": "inherit", "fontSize": "14px", "fontWeight": "600", "display": "block", "textAlign": "center", "padding": "2px 6px", "lineHeight": "1.4" }}>
                {' '}
                <span style={css(v.featureLineStyle)}>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "0s" }}>
                    I
                  </span>
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "-0.13s" }}>
                    d
                  </span>
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.07s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.34s", "animationDelay": "-0.21s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.42s", "animationDelay": "-0.04s" }}>
                    t
                  </span>
                  <span style={{ "animationDuration": "0.28s", "animationDelay": "-0.17s" }}>
                    j
                  </span>
                  <span style={{ "animationDuration": "0.36s", "animationDelay": "-0.1s" }}>
                    e
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.32s", "animationDelay": "-0.24s" }}>
                    v
                  </span>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "-0.19s" }}>
                    o
                  </span>
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "-0.02s" }}>
                    o
                  </span>
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.15s" }}>
                    r
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.34s", "animationDelay": "0s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.42s", "animationDelay": "-0.13s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.28s", "animationDelay": "-0.07s" }}>
                    n
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.36s", "animationDelay": "-0.21s" }}>
                    f
                  </span>
                  <span style={{ "animationDuration": "0.32s", "animationDelay": "-0.04s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "-0.17s" }}>
                    a
                  </span>
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "-0.1s" }}>
                    t
                  </span>
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.24s" }}>
                    u
                  </span>
                  <span style={{ "animationDuration": "0.34s", "animationDelay": "-0.19s" }}>
                    r
                  </span>
                  <span style={{ "animationDuration": "0.42s", "animationDelay": "-0.02s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.28s", "animationDelay": "-0.15s" }}>
                    ?
                  </span>
                </span>
                <span style={css(v.featureLineStyle)}>
                  <span style={css(v.featureSpaceStyle)} />
                  <span style={{ "animationDuration": "0.36s", "animationDelay": "0s" }}>
                    G
                  </span>
                  <span style={{ "animationDuration": "0.32s", "animationDelay": "-0.13s" }}>
                    o
                  </span>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "-0.07s" }}>
                    o
                  </span>
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "-0.21s" }}>
                    i
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.04s" }}>
                    h
                  </span>
                  <span style={{ "animationDuration": "0.34s", "animationDelay": "-0.17s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.42s", "animationDelay": "-0.1s" }}>
                    t
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.28s", "animationDelay": "-0.24s" }}>
                    i
                  </span>
                  <span style={{ "animationDuration": "0.36s", "animationDelay": "-0.19s" }}>
                    n
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.32s", "animationDelay": "-0.02s" }}>
                    d
                  </span>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "-0.15s" }}>
                    e
                  </span>
                  <span style={{ "width": ".3em" }} />
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "0s" }}>
                    i
                  </span>
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.13s" }}>
                    d
                  </span>
                  <span style={{ "animationDuration": "0.34s", "animationDelay": "-0.07s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.42s", "animationDelay": "-0.21s" }}>
                    e
                  </span>
                  <span style={{ "animationDuration": "0.28s", "animationDelay": "-0.04s" }}>
                    ë
                  </span>
                  <span style={{ "animationDuration": "0.36s", "animationDelay": "-0.17s" }}>
                    n
                  </span>
                  <span style={{ "animationDuration": "0.32s", "animationDelay": "-0.1s" }}>
                    b
                  </span>
                  <span style={{ "animationDuration": "0.3s", "animationDelay": "-0.24s" }}>
                    u
                  </span>
                  <span style={{ "animationDuration": "0.38s", "animationDelay": "-0.19s" }}>
                    s
                  </span>
                  <span style={{ "animationDuration": "0.26s", "animationDelay": "-0.02s" }}>
                    .
                  </span>
                </span>
                {' '}
              </button>
            </div>
          </div>
          {' '}
        </div>
      </div>
    </>
  );
}
